import { Typography } from "@material-ui/core";
import { acceptanceStatusColors } from "../../containers/financials/documents/invoices/decisions/AcceptanceStatus";
import { FinancialDataPointStatus } from "../../types/graphql-global-types";
import { useTranslation } from "react-i18next";

export function StatusOption({ status, count }: { status: string; count: number }) {
	const { t } = useTranslation();
	return (
		<Typography style={{ whiteSpace: "nowrap", color: acceptanceStatusColors[status as FinancialDataPointStatus], fontWeight: 600 }}>
			{t(status)} ({count})
		</Typography>
	);
}
